import { updateMapData } from '@bpd-library/components';
import {
    ExtendedConstructionNumber,
    findProjectPhase,
    findPropertyType,
} from '@bpd-library/utilities';
import { getFilteredData, getSoldProjectsData, updateView, View } from '@features/properties/store';
import { hasConsent } from '@store/service-consent';
import getExtendedAreaMapData from '@utilities/api-utilities/get-extended-area-map-data';
import { RouteHandler } from '@utilities/hooks/use-routing';

import { usePropertiesRouting } from '../hooks/use-properties-routing';
import { setPropertiesMapBounds } from '../utilities/bounding-box';
import {
    shouldToggleSoldProjectPolygon,
    toggleSoldProjectPhaseConstructionNumberPolygons,
} from '../utilities/sold-project-phase-data';

const constructionNumberRoute: RouteHandler = ({ slug, viewId }) => {
    const { setRoute } = usePropertiesRouting();
    let dataType: View['dataType'] = 'default';
    let parentViewApiObject:
        | { constructionNumbers?: ExtendedConstructionNumber[]; name?: string | null }
        | undefined;

    const data = getFilteredData();
    const propertyType = findPropertyType(data?.propertyTypes ?? [], { id: slug });

    const soldData = getSoldProjectsData();
    const soldProjectPhase = findProjectPhase(soldData?.projectPhases ?? [], { id: slug });

    parentViewApiObject = soldProjectPhase ?? propertyType;
    const viewName = parentViewApiObject?.name;

    if (!parentViewApiObject) {
        if (!data) return;
        parentViewApiObject = data;
        dataType = 'recommended';
    }

    let constructionNumbers = parentViewApiObject.constructionNumbers;

    if (soldProjectPhase) {
        toggleSoldProjectPhaseConstructionNumberPolygons(soldProjectPhase, true);
        dataType = 'soldConstructionNumbers';
    } else {
        constructionNumbers = constructionNumbers?.filter((cn) =>
            data?.constructionNumbers.includes(cn),
        );
    }

    updateView({
        type: 'constructionNumber',
        data: constructionNumbers || [],
        dataType,
        slug,
        viewId,
        name: viewName,
        onReturn: () => {
            if (soldProjectPhase) {
                toggleSoldProjectPhaseConstructionNumberPolygons(soldProjectPhase, false);
            }
            setRoute({
                to: 'propertyType',
            });
        },
    });

    if (hasConsent('mapbox')) {
        const mapData = getExtendedAreaMapData({
            constructionNumbers,
            propertyTypes: propertyType && [propertyType],
            ...(shouldToggleSoldProjectPolygon(soldProjectPhase) && {
                projectPhases: [soldProjectPhase!],
            }),
        });

        updateMapData(mapData);
        setPropertiesMapBounds(data ?? soldData!, mapData);
    }
};

export { constructionNumberRoute };
